import landing from "./landing";
import auth from "./auth.ts";
import registration from "./registration.ts";
import balance from "./balance.ts";
import organization from "./organization";
import shop from "./shop";
import tariff from "./tariff";
import employee from "./employee";
import documents from "./documents";
import history from "./history";
import clients from "./clients";
import wallet from "./wallet";

import files from "./files";
import catalog from "./catalog";

export default {
  auth,
  registration,
  balance,
  organization,
  shop,
  landing,
  tariff,
  employee,
  documents,
  history,
  clients,
  wallet,
  catalog,

  files,

  //SYSTEM
  sys: {
    error: "Хато: ",
    descError: "Тавсиф: ",
    wrongLogin: "Логин нодуруст",
    wrongPass: "Парол нодуруст",
    unknown: "Номаълум",
    unauthenticated: "Авторизација нашудааст",
    iikAlready: "Шахси ҳуқуқӣ бо ҳамин ИИК аллакай мавҷуд аст",
    noMoney: "Баланси пуқӣ кофӣ нест",
    wrongPeriod: "ProPlus танҳо барои як сол",
    noPermissions: "Истифодабаранда иҷозатҳои зарурӣ надорад.",
    firstLoginManager: "Аввалин бор ворид шудан, парол эҷод кунед",
    limitShops: "Эҷоди нуқти тиҷорат бо тариф маҳдуд карда шудааст",
    limitLegalEntity: "Эҷоди шахси ҳуқуқӣ бо тариф маҳдуд карда шудааст",
    wrongTariff: "Дар тарифи шумо ин дастрас нест",
    wrongTariffPromo: "Рамзи ташвиқ барои сабти ном мувофиқ нест",
    tagExist: "Ин тег аллакай мавҷуд аст",
    503: "Сервер дастрас нест",
    blockManager: "Менеҷер баст шудааст",
    wrongCode: "Рамзи нодуруст",
    codeExists: "Рамзи шарики нодуруст ворид шудааст",
    noExam: "Имтиҳон супорида нашудааст",
    noActivateAccount: "Ҳисоб фаъол нашудааст",
    emailExist:
      "Соҳиб бо ин почта аллакай дар хизматҳои RC GROUP сабти ном шудааст",
    userExist:
      "Соҳиб бо ин почта аллакай дар хизматҳои RC GROUP сабти ном шудааст",
    noAccepted: "Созишномаи нав қабул нашудааст",
    balanceNotEnough: "Баланси пуқӣ кофӣ нест",
    innExist: "Шахси ҳуқуқӣ бо ин ИНН аллакай мавҷуд аст",
    noTodayChangeTariff:
      "Тарифро танҳо як рӯз қабл аз поёни тарифи ҷорӣ метавон тағйир дод",
    badToken: "Ин пайванд эътибор надорад",
    wrongEmail: "Почтаи нодуруст",
    emailTaken: "Суроғаи почта аллакай ишғол шудааст",
    notAvailableCurrentTariff: "Ба тарифи ҷорӣ дастрас нест",
    dataNoCorrect: "Маълумот нодуруст аст",
    accountNotFound: "Ҳисоб ёфт нашуд",
    TPExist: "Нуқти тиҷорат аллакай мавҷуд аст",
    serverError: "Хатои сервер",
    ownerExist: "Ҳисоб ёфт нашуд",
    unauthorizedAction: "Шумо ҳуқуқи кофӣ надоред",
    legalEntityExist: "Шахси ҳуқуқӣ ёфт нашуд",
    tariffChangeOneDay:
      "Тарифро метавон як рӯз қабл аз поёни тарифи ҷорӣ тағйир дод",
    blockedByTariff: "Аз рӯи тариф баст шудааст",
    documentInProcessOfCreation: "Ҳуҷҷат дар раванди ташкил аст",
    emailAlreadyVerified: "Почтаи шумо аллакай тасдиқ шудааст!",
    emailConfirmed: "Почтаи шумо бомуваффақият тасдиқ шуд!",
    codeDoesNotExist: "Рамзи воридшуда эътибор надорад",
    defaultCashbackCanNotBeDeleted:
      "Мукофот барои муштариёне ки корти брендӣ надоранд, нест карда намешавад",
    cashbackUpdateSuccessful: "Фоизи мукофот бомуваффақият нав шуд",
    cashbackDeleteSuccessful: "Мукофот нест карда шуд",
    cashbackCreateSuccessful: "Мукофот эҷод шуд",
    fullCashback: "Муштарӣ бе корти брендӣ",
    clientGroupAlreadyInUse:
      "Гурӯҳи муштариён аллакай дар гурӯҳи кешбек истифода мешавад",
    enteredAmountIsAlreadyInUse:
      "Маблағи воридшудаи мукофот аллакай қайд шудааст",
    dateStartIsInvalid: "Санаи оғози давра нодуруст ворид шудааст",
    dateEndIsInvalid: "Санаи поёни давра нодуруст ворид шудааст",
    organizationNotConfirmed: "Шахси ҳуқуқӣ тасдиқ нашудааст",
    periodNotAvailable: "Давраи интихобшуда барои харид дастрас нест",
    notAvailableInYourCountry: "Давраи интихобшуда барои харид дастрас нест",
    exceededActivatedPromotionLimit:
      "Танҳо 3 аксияи фаъолкардашуда барои як нуқти тиҷорат",
    tradingPointLimitOnProPlus:
      "Дар тарифи ProPlus эҷоди на зиёда аз 30 нуқти тиҷорат имконпазир аст",
    tradingPointLimitOnPromo:
      "Дар тарифи ProPlus эҷоди на зиёда аз 15 нуқти тиҷорат имконпазир аст",
    tradingPointLimitOnLight:
      "Дар тарифи ProPlus эҷоди на зиёда аз 5 нуқти тиҷорат имконпазир аст",
    wrongDateOrder: "Санаи оғози давра бояд қабл аз санаи поёни давра бошад",
    descriptionFormatInvalid: "Тавсиф набояд хештег ва эмодзи дошта бошад",
    descriptionMustNotContainEmoji: "Тавсиф набояд эмодзи дошта бошад",
    descriptionMinLength:
      "Тавсиф бояд зиёда аз 600 аломат бошад (бе ҳисоб кардани фосилаҳо)",
    descriptionMaxLength: "Тавсиф набояд зиёда аз 3000 аломат бошад",
    maxFileSizeError: "Андозаи файл аз ҳадди 10 МБ зиёд аст",
    addFile:
      "Кашед ё <span style='color: #447ECB; cursor: pointer'>файлҳоро бор кунед</span>",
    balance: "Баланс",
    changeMainOrganizationError:
      "Тағйир додани ташкилоти асосӣ фақат баъд аз 30 рӯз аз тағйири қаблӣ имконпазир аст",
    resetWallet: "Бекор кардани тарҳи wallet pass муяссар нашуд",
    updateWallet: "Навсозии тарҳи wallet pass муяссар нашуд",
    userUnauthorized: "Логин ё парол нодуруст ворид шудааст",
    noData: "Маълумот нест",
    kb: "КБ",
    dateMask: "рр.мм.сссс",
    sort: "Ба тартиб додан",
    noDataTitle: "То ҳол маълумот нест",
    syncError: "Мушкилии синхронизатсия. Баъдтар аз нав кӯшиш кунед.",

    enterName: "Номро ворид кунед",
    countries: {
      ru: "Русия",
      kz: "Қазоқистон",
      md: "Молдова",
      ky: "Қирғизистон",
    },
    select_country: "Кишварро интихоб кунед",
    country: "Кишвар",
    q_date: {
      days: "Якшанбе_Душанбе_Сешанбе_Чоршанбе_Панҷшанбе_Ҷумъа_Шанбе",
      daysShort: "Яш_Дш_Сш_Чш_Пш_Ҷм_Шн",
      months:
        "Январ_Феврал_Март_Апрел_Май_Июн_Июл_Август_Сентябр_Октябр_Ноябр_Декабр",
      monthsShort: "Янв_Фев_Мар_Апр_Май_Июн_Июл_Авг_Сен_Окт_Ноя_Дек",
    },
    errorTitle: "Чизе хатогӣ рӯй дод",
    dateFrom: "Маълумот аз ",
    dateToToday: " то имрӯз дастрас аст",
    dateFormat: "Формати рр.мм.сссс ё рр.мм.сссс - рр.мм.сссс",
    showBy: "Нишон додан бо: ",
    showByMobile: "Бо: ",
    searchResponseEmpty: "Дар асоси дархости шумо чизе ёфт нашуд",
    search: "Ҷустуҷӯ",
    imageSize: "Мб",
    tagSearchResponseEmpty:
      "Тег ёфт нашуд. Барои илова кардани он Enter ё Фосила пахш кунед.",
    from: "Аз:",
    to: "То:",
    gender: {
      m: "Мард",
      f: "Зан",
    },
    500: "Чизе хатогӣ рӯй дод. Пайвасти интернетро санҷед.",
    soon: "Ба зудӣ!",
    fromToPercent: "Аз {from} то {to} %",
    fromToDays: "Аз {from} то {to} рӯз",
    timeFormat: "сс:мм – сс:мм",
    language: "Забон",
  },

  message: {
    changesSavedAndSendedToModeration:
      "Тағйирот захира шуда ва ба модератсия фиристода шуд",
  },

  entity: {
    title: "Маълумоти ташкилотро илова кунед",
    thirdStepTitle:
      "Лутфан, дурустии маълумотро санҷед. Акнун шумо бояд аз 24 то 48 соат интизор шавед, то мо шахси ҳуқуқии шуморо тасдиқ кунем.",
    accept: "Ман шартҳои шартномаро қабул мекунам",
    offers: "оферта",
    titleReject: "Дархост рад шуд!",
    rejectDescription:
      "Мутаассифона, маълумоти пешниҳодшудаи шумо нодуруст будан. Ҳамроҳи саҳифа ҷавоби модераторҳоро хонед ва маълумот дар бораи шахси ҳуқуқиро тағйир диҳед.",
    message: "Паём аз модераторҳо:",
    change: "Маълумотро тағйир диҳед",
    titleWaiting: "Ташаккур барои сабти ном!",
    descriptionWaiting:
      "Дар ҳоли ҳозир ташкилоти шумо модератсия мешавад. Шумо метавонед ба кабинетҳои шахсӣ дохил шавед, пас аз он ки мо дурустии маълумоти шуморо тасдиқ кунем. Одатан, санҷиш аз 24 то 48 соат давом мекунад.",
    descriptionWaitingRu:
      "<p>Дар ҳоли ҳозир ташкилоти шумо модератсия мешавад. </p> <p>Пас аз он ки мо дурустии маълумоти шуморо тасдиқ кунем шумо метавонед ба кабинети шарики RC Group дохил шавед. </p>  <p> Одатан, санҷиш аз 24 то 48 соат давом мекунад.</p>",
    descriptionWaitingRuWithoutPos:
      "<p>Дар ҳоли ҳозир ташкилоти шумо модератсия мешавад. </p> <p>Пас аз он ки мо дурустии маълумоти шуморо тасдиқ кунем шумо метавонед ба кабинети шарики RC Group дохил шавед. </p> <p> Одатан, санҷиш аз 24 то 48 соат давом мекунад.</p>",
    downloadAccept: "Ҳисобро барои пардохт зеркашӣ кунед",
    addDone: "Табрик ба эҷоди шахси ҳуқуқӣ!",
    waitingApprove:
      "<p>Дар ҳоли ҳозир шахси ҳуқуқии шумо санҷиш мешавад. Ин аз 24 то 48 соат давом мекунад.</p><p>Барои гузаронидани санҷиш шумо бояд ҳисобро аз шахси ҳуқуқии муайянкардашуда пардохт кунед, онро тавассути тугмаи поёнӣ зеркашӣ кунед. Шумо инчунин метавонед ҳисобро дар кабинетҳои шахсӣ пайдо кунед: дар бахши «Корхонаҳои ман» - «Ҳуҷҷатҳо» зери номи «Пардохти санҷишӣ».</p>",
  },

  contacts: {
    title: "Тамосҳо",
    subtitle:
      'ҶАМЪИЯТИ САҲОМИИ "КОРПОРАТСИЯИ ТЕХНОЛОГИЯҲОИ ИТТИЛООТӢ-МОЛИЯВӢ" ( ҶС "Корпоратсияи Инфинтех" ) Суроғаи ҳуқуқӣ: 191124, <br/>' +
      "Санкт-Петербург, кӯчаи Красного Текстильщика, хонаи 10-12, ҳарфи О, ошёнаи 6, ҳуҷраи 1-Н, кабинети 624 <br/> ИНН/КПП 7842216564/784201001 ОГРН 1237800080616",
    mailAddress: "Суроғаи почтаи электронӣ: ",
  },

  failed: "Хато. Амал иҷро нашуд",
  success: "Амал иҷро шуд",

  //cabinet layout
  leftPanel: {
    counterparties: "Санҷиши контрагентҳо",
    entities: "Шахсҳои ҳуқуқӣ",
    tradingPoint: "Нуқатҳои тиҷорат",
    paymentMethods: "Усулҳои пардохт",
    employees: "Кассирҳо",
    documents: "Ҳуҷҷатҳо",
    businesses: "Тиҷорат",
    tariffs: "Тарифҳо",
    historyPayment: "Таърихи амалиётҳо",
    promotions: "Аксияҳо",
    actsAndAccounts: "Ҳуҷатҳо ва ҳисобҳо",
    accrualCashback: "Нақд кардани баллҳо",
    managers: "Менеҷерҳо",
    spread: "Пахш кардани кортҳои RC",
    analytics: "Таҳлил",
    points: "Нуқтаҳо ба кассирҳо",
    enterprises: "Корхонаҳои ман",
    paymentDecision: "Қарори пардохт",
    portfolio: "Портфел",
    employees_and_managers: "Кормандони ман",
    loyalty: "Барномаи вафодорӣ",
    clients: "Муштариён",
    claims: "Дархостҳо",
    claims_history: "Таърихи дархостҳо",
    claims_groups: "Гурӯҳбандии муштариён",
    reviews: "Акколаҳо",
    extendTariff: "Амали тарифро дароз кунед",
    changeTo: "тариф ба тағйир меёбад",
    wallet: "Тарҳи корти Wallet",
    accountIs: "Шумо ҳамчун ворид шудед",
    manager: "менеҷер",
    owner: "соҳиб",
    terminals: "Дастгоҳҳои кассӣ",
    terminals_MSPOS: "RC Processing 4 дар 1",
    terminals_LIMON: "Технологияи MPOS",
    FAQ: "Муфассал дар бораи RC CITY",
    corporate: "Алоқа",
    push: "Огоҳиҳои Push-и Wallet",
    tips: "Накдӣ маслиҳатҳо",
    eMenu: "Каталоги онлайн",
    documentLaboratory: "Лабораторияи ҳуҷҷатҳо",
    giftCard: "Кортҳои тӯҳфа",
    processing: "Processing",
    services: "Хизматҳо",
    wallets: "Кортҳои вафодорӣ",
    clientsList: "Рӯйхати муштариён",
    marketplaces: "Бозорҳо",
    PromotionServices: "Ташвиқот",
    PreOrders: "Фармоишҳо",
    PWA: "Барнома насб кунед",
    tgNotifications: "Огоҳиҳо дар Telegram",
  },
  headerButtons: {
    addCoin: "Пур кардан",
    profile: "Профил",
    exit: "Баромадан",
    themLight: "Мавзӯи равшан",
    themDark: "Мавзӯи торик",
  },

  // Managing managers page
  managers: {
    title: "Менеҷерҳо",
    noManagersError: "Шумо то ҳол менеҷер надоред",
    addManager: "Менеҷер илова кунед",
    managerCreated: "Менеҷер эҷод шуд",
    managerReset: "Пароли менеҷер бозсозӣ шуд!",
    oneTimePass: "Пароли яккарата",
    messageManagerCreated:
      "Диққат! Ин паролро сабт кунед, дар аввалин воридшавии менеҷер, ӯ бояд пароли нав эҷод кунад.",
    changePass:
      "Диққат! Ин паролро сабт кунед, дар аввалин воридшавии менеҷер, ӯ бояд пароли нав эҷод кунад",
    add: {
      title: "Илова кардани менеҷер",
      second_name: "Насаби менеҷер",
      first_name: "Номи менеҷер",
      patronymic: "Номи падари менеҷер",
      position: "Вазифаи менеҷер",
      phone: "Рақами телефони менеҷер",
      permissions: "Дастрасӣ ба саҳифаҳои кабинет",
      button: "Менеҷер эҷод кунед",
    },
    //change
    changeTitle: "Тағйир додани менеҷер",
    buttonChange: "Маълумоти менеҷерро тағйир диҳед",
    buttonResetPassword: "Паролро бозсозӣ кунед",
    //reset password
    newPassword: "Пароли навро ворид кунед",
    newPassRules1: "Бояд камтар аз 8 аломат дошта бошад",
    newPassRules2: "Ҳарфҳо ва рақамҳои алифбои лотинӣ дошта бошад",
    //delete manager
    deleteManager: "Шумо мутмаин ҳастед, ки мехоҳед менеҷерро нест кунед?",
  },
  //check counterparties page
  counterparties: {
    title: "Санҷиши контрагентҳо",
    buttonCheck: "Санҷед",
    question:
      "Санаи сабти ном, ИНН, КПП, ОГРН, Навъи асосии фаъолият, Ҳолати шахси ҳуқуқӣ, ИФНС, Суроғаи ҳуқуқӣ, Директори генералӣ, Таъсисдиҳандагон, Пойгоҳи умумӣ",
    instructionButton: "Дастур барои санҷиши контрагентҳо",
    listTitle: "Чӣ тавр Ботро барои санҷиши контрагентҳо истифода барем?",
    listItemFirst:
      "ИНН ё ОГРН-и ташкилотеро, ки шумо мехоҳед санҷед, ворид кунед.",
    listItemSecond:
      "Telegram-Бот ҳамаи маълумоти зарурӣ ба шумо нишон медиҳад.",
    listItemThird:
      "Барои санҷиши ҳисобҳои басташуда, тугмаи «Санҷиши бастани ҳисобҳо»-ро пахш кунед.",
    listItemFourth:
      "Пас аз пахш кардани тугмаи «Санҷиши бастани ҳисобҳо» Бот ҳамаи ҳисобҳои басташуда (агар мавҷуд бошанд), ФНС, санаи баст, №-и қарор, асосро мувофиқи модда нишон медиҳад. Ин маълумотро барои омӯзиши муфассал дар формати PDF зеркашӣ кардан мумкин аст: тугмаи «Файли ҳисоботро зеркашӣ кунед»-ро пахш кунед.",
    instructionCardTitleFirst: "Чаро контрагентҳоро санҷем?",
    instructionCardTitleSecond: "Ба вақт оид ба ҳақиқатҳо маълумот гиред.",
    instructionCardTextFirst:
      "<p>Санҷиши контрагентҳо барои муайян кардани хатариҳои молиявӣ ва андозӣ, ки метавонанд дар кор бо контрагент пайдо шаванд, ва қабули қарорҳои асоснок - идома додан ё бекор кардани ҳамкорӣ зарур аст. <br> Бот ба таври худкор контрагентҳои нав ва ҷориро аз манбаъҳои гуногун месанҷад ва шуморо оид ба омилҳои критикӣ ва маълумоте, ки таваҷҷуҳ талаб мекунанд, огоҳ мекунад.</p>",
    instructionCardTextSecond:
      "<p>Бо ёрии бот шумо метавонед санҷиши васеъ ва мониторинги тағйиротҳо дар тамоми пойгоҳи контрагентҳо ё дар як пойгоҳи муайянкардашуда анҷом диҳед. Ин имкон медиҳад, ки ба тағйироти муҳим дар муштариён ва шарикон ба вақт ҷавоб диҳед, хатари бозгашти пулро коҳиш диҳед.</p>",
  },

  // Claims and history claims page
  claims: {
    title: "Дархостҳо",
    historytitle: "Таърихи дархостҳо",
    group_name: "Номи гурӯҳ",
    group_nomination: "Номи гурӯҳ",
    group_sum: "Маблағи харидҳо (бе ҳисоб кардани тахфифҳо)",
    create_group: "Гурӯҳи нав эҷод кунед",
    edit_group: "Гурӯҳро таҳрир кунед",
    delete_group: "Шумо мутмаин ҳастед, ки мехоҳед гурӯҳро нест кунед?",
    sum: "Маблағ",
    percent: "Фоизи нақд кардан",
    noClients: "То ҳол шумо ягон муштарӣ надоштед",
    oneClient: "Шумо танҳо як муштарӣ доштед",
  },
  // Reviews page
  review: {
    title: "Акколаҳо дар RC PAY",
    pageHint:
      "Ин зербахш барои гирдоварии фикрҳо аз тарафи ташрифоварандагони муассисаҳои шумо пешбинӣ шудааст, ки дар сомонаи rcpay.ru ҷойгир карда мешавад. Шумо метавонед худатон идора кунед, ки кадом акколаҳо намоиш дода шаванд, ба аломати «чашм» клик кунед.",
    goodFirst: "Аввал мусбат",
    badFirst: "Аввал манфӣ",
    newFirst: "Аз рӯи навӣ",
    noTradingPointsData:
      "Барои дидани акколаҳо, зарур аст нуқти тиҷорат эҷод кунед",
    hint: "Акколаҳо вобаста ба филтри санаҳо мебошанд",
    noReviews: "Шумо то ҳол акколаҳо надоред",
    all: "Ҳамаи акколаҳо",
    shown: "Намоишдодашаванда",
    hidden: "Пинҳон",
    hideStatus:
      "Аз саҳифаи нуқти тиҷорати шумо дар сомонаи rcpay.ru пинҳон карда шавад?",
    showStatus:
      "Дар саҳифаи нуқти тиҷорати шумо дар сомонаи rcpay.ru намоиш дода шавад?",
    noDataLabel: "Маълумот дар бораи акколаҳо нест",
    noTradingPointText: "Шумо то ҳол Нуқатҳои тиҷорат надоред",
    noReview:
      "Истифодабарандагон то ҳол дар бораи Нуқати тиҷорати Шумо акколаҳо нагузоштаанд",
  },

  //analytic page
  analytics: {
    title: "Таҳлил",
    organizationSelect: "Шахси ҳуқуқӣ интихоб кунед",
    organizationButton: "Шахсҳои ҳуқуқӣ",
    organizationCheckbox: "Ҳамаи ташкилотҳо",
    newOrganizationCheckbox: "Ҳамаи шахсҳои ҳуқуқӣ",
    calendar: "Тақвим",
    organizations: {
      newClients: "Муштариёни нав",
      allClients: "Ҳамаи муштариён",
      sales: "Фурӯш",
      amount: "Маблағи фурӯш",
      amountCashback: "Аз онҳо бо баллҳо дода шудааст",
      average: "Чеки миёна",
      averageCashback: "Мукофоти миёна",
    },
    countClients: "Миқдори муштариён",
    topSumEmployee: "Кассирҳои болоӣ аз рӯи маблағи фурӯш",
    topSaleEmployee: "Кассирҳои болоӣ аз рӯи фурӯш",
    points: "Нуқтаҳо",
    addPoints: "Нақд. баллҳо",
    writePoints: "Бо баллҳо қабул шуд",
    rfmAnalysis: "Таҳлили RFM",
    rfmGroupSizes: "Андозаҳои гурӯҳҳои RFM",
    clientPortrait: {
      btn: "Портрети муштарӣ",
      title: "Муштариён",
      customerCount: "Миқдори муштариён:",
      receiptAvg: "Чеки миёна:",
      receiptCount: "Миқдори фурӯш:",
      receiptSum: "Маблағи фурӯш:",
      maleFemale: "М/З:",
      noGender: "Ҷинс муайян нашудааст:",
    },
  },

  // Cashback page
  cashback: {
    title: "Нақд кардани баллҳо",
    subTitle:
      "<b>Диққат диҳед!</b><br>Муштариёни тарифи <b>FREE</b> <b>25%</b> мегиранд,<br> Муштариёни тарифи <b>SMART</b> <b>50%</b> мегиранд,<br> Муштариёни <b>рақамии</b> шумо <b>50%</b> мегиранд<br> (комиссия гирифта намешавад)<br><br><a href='/public/docs/reward_scenario_1.0.pdf' target='_blank'>Сценарийҳои тақсимоти мукофотро бубинед</a>",
    statusName: "Муштариён бе корти брендӣ",
    delay: "Таъхири нақд кардан (Дар рӯзҳо)",
    setDelay: "Таъхирро тағйир диҳед",
    editDelay: "Таъхири нақд карданро тағйир диҳед",
    maxDelay: "Максималии таъхир 14 рӯз",
    setReward: "Мукофотро таъин кунед",
    selectGroup: "Гурӯҳро интихоб кунед",
    rewardPercent: "Фоизи нақд карданро ворид кунед",
    minReward: "Минималии фоизи нақд кардан - 4",
    maxReward: "Максималии фоизи нақд кардан - 25",
    delayTitle: "Таъхири ҷории нуқти тиҷорат:",
    withoutActiveWait:
      "Истифодабарандаи шумо мукофотро дар давоми 30 дақиқа аз лаҳзаи анҷоми амалиёт хоҳад гирифт",
  },

  // Spread page
  spread: {
    title: "Пахш кардани кортҳои RC",
    p1: "Ин рамзерро сканер карда, муштариёни шумо метавонанд корт гиранд.",
    inviteClients: "Муштариёнро даъват кунед",
    p2: "Мо тавсия медиҳем, ки табли бо QR-рамз ва навишти «Корти бонусӣ зеркашӣ кун! Баллҳои бонусӣ ҷамъ куну ва шароити махсус барои харид гир!» дар наздикии касса ё ҷое, ки харидороњои шумо ҳисоб мекунанд, ҷойгир кунед. Масалан, дар мизҳои кафе, дар минтақаи интизорӣ дар назди касса дар мағоза, ё дар ҷойи дигар ба тавре, ки муштариёни шумо ин маълумотро таҳқиқан бубинанд.",
    getCard: "Гирифтани корт тавассути пайванд",
    ttl1: "Гирифтани корт тавассути RC KASSA",
    p4: "Барномаи RC KASSA-ро барои намоиши QR-рамзи худ истифода баред: барои ин ба пункти меню «Корти Wallet-ро диҳед» гузаред. Муштарӣ таклиф кунед, ки рамзро бо телефон сканер кунад. Гарчанди ки гирифтани корт ба ин тарз сода аст, мо тавсия медиҳем, ки QR-рамзро чоп кунед ва онро бо даъват ба амал дар наздикии касса ҷойгир кунед.",
    ttl2: "Кор бо кормандон",
    p5: "Таҷрибаи ҷаҳонӣ нишон медиҳад, ки кормандон аксар вақт ворид кардани барномаҳои вафодориро бойкот мекунанд. Ин на танҳо ба кортҳои пластикии куҳна, балки ба ҳалли рақамӣ, ба монанди RC Group, низ дахл дорад. Ба бисёре аз кормандон метавонд чунин ба назар расад, ки дар бораи барномаи вафодорӣ ба муштариён гап задан, онҳо даромади ташкилотро коҳиш медиҳанд. Ин даъво нодуруст аст. Ҳар қадре ки паҳншавии барномаи вафодорӣ баландтар бошад, чеки миёна, зичии харидҳо ва вафодорӣ ба бренд баландтар аст. Илова бар ин, паҳншавии баланди барнома ба коҳиш додани хароҷоти тиҷорат барои SMS ва дигар фиристоданиҳо ва шинохтани беҳтари муштариёни худ имкон медиҳад.",
    coped: "Нусхабардорӣ шуд",

    faq: [
      {
        title: "Ҷойгиркунӣ",
        text: "Мо тавсия медиҳем, ки табли бо QR-рамз ва навишти «Корти бонусӣ зеркашӣ кун! Баллҳои бонусӣ ҷамъ куну ва шароити махсус барои харид гир!» дар наздикии касса ё ҷое, ки харидороњои шумо ҳисоб мекунанд, ҷойгир кунед. Масалан, дар мизҳои кафе, дар минтақаи интизорӣ дар назди касса дар мағоза, ё дар ҷойи дигар ба тавре, ки муштариёни шумо ин маълумотро таҳқиқан бубинанд.",
      },
      {
        title: "Гирифтани корт тавассути RC KASSA",
        text: 'Барномаи RC KASSA-ро барои намоиши QR-рамзи худ истифода баред: барои ин ба кунҷи болои рост се нуқтаи сиёҳ клик кунед ва "QR-рамзро кушодан"-ро интихоб кунед. Муштарӣ таклиф кунед, ки рамзро бо телефон сканер кунад.',
      },
      {
        title: "Кор бо кормандон",
        text: "Таҷрибаи ҷаҳонӣ нишон медиҳад, ки кормандон аксар вақт ворид кардани барномаҳои вафодориро бойкот мекунанд. Ин на танҳо ба кортҳои пластикии куҳна, балки ба ҳалли рақамӣ, ба монанди RC Group, низ дахл дорад. Ба бисёре аз кормандон метавонд чунин ба назар расад, ки дар бораи барномаи вафодорӣ ба муштариён гап задан, онҳо даромади ташкилотро коҳиш медиҳанд. Ин даъво нодуруст аст. Ҳар қадре ки паҳншавии барномаи вафодорӣ баландтар бошад, чеки миёна, зичии харидҳо ва вафодорӣ ба бренд баландтар аст. Илова бар ин, паҳншавии баланди барнома ба коҳиш додани хароҷоти тиҷорат барои SMS ва дигар фиристоданиҳо ва шинохтани беҳтари муштариёни худ имкон медиҳад.",
      },
    ],

    faqNko: [
      {
        title: "Ҷойгиркунӣ",
        text: "Мо тавсия медиҳем, ки табли бо QR-рамз ва навишти «Корти бонусӣ зеркашӣ кун! Баллҳои бонусӣ ҷамъ куну ва шароити махсус барои харид гир!» дар наздикии касса ё ҷое, ки харидороњои шумо ҳисоб мекунанд, ҷойгир кунед. Масалан, дар мизҳои кафе, дар минтақаи интизорӣ дар назди касса дар мағоза, ё дар ҷойи дигар ба тавре, ки муштариёни шумо ин маълумотро таҳқиқан бубинанд.",
      },
      {
        title: "Кор бо кормандон",
        text: "Таҷрибаи ҷаҳонӣ нишон медиҳад, ки кормандон аксар вақт ворид кардани барномаҳои вафодориро бойкот мекунанд. Ин на танҳо ба кортҳои пластикии куҳна, балки ба ҳалли рақамӣ, ба монанди RC Group, низ дахл дорад. Ба бисёре аз кормандон метавонд чунин ба назар расад, ки дар бораи барномаи вафодорӣ ба муштариён гап задан, онҳо даромади ташкилотро коҳиш медиҳанд. Ин даъво нодуруст аст. Ҳар қадре ки паҳншавии барномаи вафодорӣ баландтар бошад, чеки миёна, зичии харидҳо ва вафодорӣ ба бренд баландтар аст. Илова бар ин, паҳншавии баланди барнома ба коҳиш додани хароҷоти тиҷорат барои SMS ва дигар фиристоданиҳо ва шинохтани беҳтари муштариёни худ имкон медиҳад.",
      },
    ],
  },

  // Push notifications page
  notifications: {
    title: "Огоҳиҳои Push",
    modal:
      "Фиристоданиҳо дар кор аст, Пуш-огоҳиҳо дар давоми 15 дақиқа ба истифодабарандагони шумо мерасад",
    description:
      "Матнро бо диққат хонед. Пас аз эҷоди огоҳӣ, тағйир додани он <span>имконнопазир</span> хоҳад буд.",
    notificationText: "Матни огоҳӣ",
    sendError: "Фиристодани Push-огоҳӣ муяссар нашуд",
    sendTime: "Ба вақти Маскав",
    noNotifications: "Шумо огоҳиҳои push эҷодкарда надоред",
    buttonNoData: "Паёми PUSH эҷод кунед",
    table: {
      shopName: "Номи нуқти тиҷорат",
      header: "Сарлавҳа",
      date: "Сана",
      time: "Вақт",
    },

    view: {
      shop: "Нуқти тиҷорат",
      header: "Сарлавҳа",
      message: "Матни паём",
      date: "Сана",
      time: "Вақт",
    },

    create: {
      warning:
        "Матнро бо диққат хонед. Пас аз эҷоди огоҳӣ, тағйир додани он <span>имконнопазир</span> хоҳад буд.",
      shop: "Интихоби нуқти тиҷорат",
      header: "Матни сарлавҳа",
      message: "Матни паём",
      button: "Фиристоданиҳо эҷод кунед",
      messageAfterCreate:
        "Фиристоданиҳо дар кор аст, Пуш-огоҳиҳо дар давоми 15 дақиқа ба истифодабарандагони шумо мерасад",
    },
  },

  // Answer moderation
  status: {
    moderation: "Дар модератсия",
    confirmation: "Тасдиқ шуд",
    confirm: "Тасдиқ шуд",
    reject: "Рад шуд",
    reject2: "Рад шуд",
    paid: "Пардохт шуд",
    active: "Фаъол",
    locked: "Баст шуд",
    activateProcess: "Дар раванди фаъолсозӣ",
    awaitingPayment: "Интизори пардохт",
    sent: "Фиристода шуд",
    received: "Қабул шуд",
    canceled: "Бекор карда шуд",
    unknown: "Номаълум",
    awaitingDocs: "Интизори боркунии ҳуҷҷат",
    base: "Асосӣ",
    inProgress: "Дар кор",
    completed: "Анҷом ёфт",
    new: "Нав",
    readyForIssue: "Барои додан омода аст",
    issuedToClient: "Ба муштарӣ дода шуд",
    undefined: "Номаълум",
    performed: "Иҷро шуд",
    inWaiting: "Дар интизорӣ",
  },

  // Table
  table: {
    searchByTable: "Ҷустуҷӯ дар ҷадвал",
    status: "Ҳолат",
    nameStatus: "Номи статус",
    percentageAccrual: "Фоизи нақд кардан",
    fullName: "Ному насаб",
    position: "Вазифа",
    phone: "Рақами телефон",
    login: "Логин",
    number: "Рақам",
    sum: "Маблағ",
    customer: "Харидор",
    cashback: "Баллҳо",
    currency: "Асъор",
    dateTime: "Сана ва вақт",
    date: "Сана",
    paid: "Пардохт шуд",
    purchase: "Аз харид ба",
    transaction: "Транзаксия",
    type: "Навъ",
    points: "Нуқтаҳо",
    name: "Ном",
    visits: "Зичии ташрифҳо",
    averageCheck: "Маблағи харидҳо",
    birthday: "Зодрӯз",
    age: "Синну сол",
    nameAndSurname: "Насаб ва Ном",
    store: "Нуқти тиҷорат",
    entityName: "Номи ташкилот",
    operationType: "Навъи амалиёт",
  },

  // Common text
  common: {
    nodata: "Шумо то ҳол нуқти тиҷорат надоред",
    buttonNoData: "Нуқти тиҷорат эҷод кунед",
    organizationSelect: "Ташкилотро интихоб кунед",
    allOrganizationCheckbox: "",
    tradingPointsSelect: "Нуқти тиҷоратро интихоб кунед",
    allTradingPointsCheckbox: "Ҳамаи нуқатҳои тиҷорат",
    from: "аз",
    util: "то",
    to: "то",
    fillField: "Ин майдонро пур кунед",
    invalidEmail: "Почтаи нодуруст",
    minLengthPass: "Парол на камтар аз 8 аломат",
    fillTime: "Вақтро пур кунед",
    calendar: "Тақвим",
    filter: "Филтр",
    filters: "Филтрҳо",
    back: "Бозгашт",
    loadDescription: "Лутфан, сертификати ҳалолӣ-ро бор кунед:",
    loadFormat: "Сертификатҳо дар форматҳои .PDF .JPG .PNG дастгирӣ мешаванд",
    loadSize: "Вазни файл набояд зиёда аз 10 МБ бошад",
    dropFiles: "Файлро инҷо кашед ё",
    uploadFiles: "бор кунед",
    chooseFile: "Файлро интихоб кунед",
    fileName: "Номи файл",
    Monday: "Душанбе",
    Tuesday: "Сешанбе",
    Wednesday: "Чоршанбе",
    Thursday: "Панҷшанбе",
    Friday: "Ҷумъа",
    Saturday: "Шанбе",
    Sunday: "Якшанбе",
    MondayShort: "Дш",
    TuesdayShort: "Сш",
    WednesdayShort: "Чш",
    ThursdayShort: "Пш",
    FridayShort: "Ҷм",
    SaturdayShort: "Шн",
    SundayShort: "Яш",
    1: "Душанбе",
    2: "Сешанбе",
    3: "Чоршанбе",
    4: "Панҷшанбе",
    5: "Ҷумъа",
    6: "Шанбе",
    7: "Якшанбе",
    dayAndNightTime: "Нуқта шабонарӯз кор мекунад",
    notWorkTime: "Нуқта кор намекунад",
    month: "моҳ",
    mo: "моҳ",
    year: "сол",
    organizations: "Ташкилотҳо",
    shops: "Нуқатҳои тиҷорат",
    employees: "Кассирҳо",
    managers: "Менеҷерҳо",
    manager: "Менеҷер",
    owner: "Соҳиб",
    business: "Тиҷорат",
    tariffs: "Тарифҳо",
    historyOperations: "Таърихи амалиётҳо",
    actsAndAccounts: "Ҳуҷатҳо ва ҳисобҳо",
    cashback: "Нақд кардани баллҳо",
    documents: "Ҳуҷҷатҳо",
    addBalance: "Пардохти пешакӣ",
    addPoints: "Нақд кардани нуқтаҳо",
    application: "Пардохти дастгоҳи кассӣ",
    claims: "Дархостҳо",
    analytics: "Таҳлил",
    sortNew: "Аз рӯи навӣ",
    sortAscStars: "Аз рӯи камшавии ситораҳо",
    sortDscStars: "Аз рӯи афзоиши ситораҳо",
    email: "email",
    lastName: "Насаб",
    firstName: "Ном",
    error404: "Хатои 404",
    noPage: "Саҳифа ёфт нашуд",
    errorTypeFile: "Навъи файл нодуруст!",
    tryTypeFile: "Файл бояд jpg ё png бошад",
    clients: "Муштариён",
    exitAccount: "Аз ҳисоб баромадан",
    accountsForAct: "Ҳисоб барои ҳуҷат",
    downloadOn: "дастрас аст дар",
    downloadOnRuStore: "аз зеркашӣ кунед",
    phone: "Телефон",
    comment: "Шарҳ",
    pcs: "дона",
    gb: "ГБ",
    min: "дақ",
    group: "Гурӯҳ",
    emptyField: "Ҳамаи майдонҳоро пур кунед",
    correctField: "Ҳамаи майдонҳо бояд дуруст бошанд!",
    bigFile: "Андозаи калони файл",
    "e-menu": "Менюи электронӣ",
    "document-laboratory": "Лабораторияи ҳуҷҷатҳо",
    changesNotSaved: "Тағйироти воридшуда захира нашудаанд",
    statuses: "Статусҳо",
    phoneNumber: "Рақами телефон",
    mail: "Почтаи электронӣ",
    tgBot: "Боти Telegram",
  },

  // Buttons
  button: {
    invite: "Даъват кардан",
    download: "Зеркашӣ кардан",
    edit: "Таҳрир кардан",
    save: "Захира кардан",
    saveChange: "Тағйиротро захира кунед",
    saveAndQuit: "Захира карда ва баромадан",
    accept: "Қабул кардан",
    change: "Тағйир додан",
    login: "Ворид шудан",
    create: "Эҷод кардан",
    confirm: "Тасдиқ кардан",
    details: "Муфассал",
    copy: "Нусха бардоштан",
    topUp: "Пур кардан",
    back: "Бозгашт",
    send: "Фиристодан",
    sendAgain: "Такрор фиристодан",
    sendCode: "Рамз фиристодан",
    next: "Баъдӣ",
    proceed: "Идома додан",
    buy: "Харидан",
    goto: "Гузариш",
    open: "Кушодан",
    delete: "Нест кардан",
    cancel: "Бекор кардан",
    cancel2: "Бекор кардан",
    yesCancel: "Ҳа, бекор кунед",
    yesQuit: "Ҳа, баромед",
    yesDelete: "Ҳа, нест кунед",
    pay: "Пардохт кардан",
    ok: "Хуб!",
    cancelClaim: "Дархостро бекор кунед",
    generate: "Тавлид кардан",
    apply: "Татбиқ кардан",
    applyAndClose: "Татбиқ карда ва пӯшидан",
    reset: "Бозсозӣ",
    clearAll: "Ҳамаро тоза кардан",
    calendarButton: {
      today: "Имрӯз",
      yesterday: "Дирӯз",
      lastWeek: "7 рӯзи охир",
      last30Days: "30 рӯзи охир",
      lastMonth: "Моҳи гузашта",
      thisMonth: "Ин моҳ",
      lastYear: "Соли гузашта",
      thisYear: "Соли ҷорӣ",
      allPeriod: "Ҳамаи давра",
      selectRange: "Давраи шахсӣ",
    },
    preview: "Пешнамоиш",
    resetAll: "Ҳамаро бозсозӣ кунед",
    showResult: "Натиҷаҳоро нишон диҳед",
    upload: "Бор кардан",
    expand: "Кушодан",
    hide: "Пинҳон кардан",
    try: "Санҷед",
    add: "Илова кардан",
    reveal: "Нишон додан",
    readAll: "Ҳамаро хондан",
    collapse: "Фуруд овардан",
    logout: "Баромадан",
    show: "Нишон додан",
    moreDetails: "Муфассалтар",
    settings: "Танзимот",
    rollUp: "Фуруд овардан",
    toTariffs: "Ба тарифҳо",
    forModeration: "Ба модератсия",
    quitWithoutSaving: "Бе захира кардан баромадан",
    downloadInvoice: "Ҳисобро зеркашӣ кунед",
    notNow: "Ҳоло не",
    createCashier: "Кассир эҷод кунед",
    clearly: "Тоза",
    toEdit: "Ба таҳрир",
    skip: "Гузаронидан",
    backAndSave: "Бозгаштед ва захира кунед",
    done: "Тайёр",
    close: "Пӯшидан",
  },

  month: {
    1: "Январ",
    2: "Феврал",
    3: "Март",
    4: "Апрел",
    5: "Май",
    6: "Июн",
    7: "Июл",
    8: "Август",
    9: "Сентябр",
    10: "Октябр",
    11: "Ноябр",
    12: "Декабр",
  },

  charts: {
    pointsAccrued: "Баллҳои нақдшуда",
    pointsWritten: "Бо баллҳо қабул шуд",
  },

  eMenu: {
    noData: {
      title: "Маълумот дар бораи менюи электронӣ нест",
      noTradingPoints: "Шумо то ҳол Нуқатҳои тиҷорат надоред",
      noProducts: "Шумо то ҳол ягон маҳсулот эҷод накардед",
    },
  },

  validationErrors: {
    emptyField: "Майдон наметавонад холӣ бошад",
    invalidEmailFormat: "Почтаи электрониро ба намуди {email} ворид кунед",
    invalidSiteFormat: "URL бояд http:// ё https:// дошта бошад",
    invalidFormat: "Формати нодуруст",
    incorrectValueStart: "Қимати аз",
    incorrectValueEnd: "то зарур аст",
    invalidValueMaxLength: "Максималии миқдори аломатҳо ",
    invalidValueMinLength: "Минималии миқдори аломатҳо ",
    invalidHouseNumber: "Рақами хонаро такмил диҳед",
    invalidAddress: "Суроғаро такмил диҳед",
    invalidWorkDays: "Ақалан як рӯзи кории интихоб карда зарур аст",
    invalidWorkTime: "Формати нодурусти вақт",
    errorWorkTime:
      "Вақти кушодан наметавонад пас аз вақти бастан ё бо он рост ояд",
    notEnoughElement: "Миқдори норасидаи элементҳо",
    manyElement: "Шумо миқдори максималии элементҳоро зиёд кардед",
    maxLessMin: "Камтар аз минималӣ",
    invalidAge: "Синну соли нодуруст",
    minDate: "Сана бояд на дертар аз {date} бошад",
    maxDate: "Сана бояд на пештар аз {date} бошад",
    requiredPhone: "Рақами телефонро ворид кунед",
    reqiredPromocode: "Рамзи ташвиқ нодуруст ворид шудааст",
    requiredCountry: "Кишварро интихоб кардан зарур аст",
    havePhone: "Ин телефон аллакай сабти ном шудааст",
    haveMail: "Ин почта аллакай сабти ном шудааст",
    invalidEmail: "Почтаи нодуруст",
    email: "Почтаро ворид кунед",
    first_name: "Номро ворид кунед",
    last_name: "Насабро ворид кунед",
    password: "Паролро ворид кунед",
    corresp_account: "Ҳисоби корӣ зарур аст",
    number_account: "Рақами ҳисоби ҳисоббаробаркунӣ зарур аст",
    commercial_account_number:
      "Ҳисоби ҳисоббаробаркунӣ бояд ба шахси ҳуқуқӣ ё ИП тааллуқ дошта бошад",
    bik_of_bank: "БИК-и бонк зарур аст",
    international_bank: "Рақами байналмилалии ҳисоби бонкӣ зарур аст",
    vat_code: "Рамзи НДС зарур аст",
    inn: "ИНН зарур аст",
    entityAddress: "Суроғаи ҳуқуқӣ зарур аст",
    fullName: "Ному насаб зарур аст",
    ogrn: "ОГРН зарур аст",
    monthly_turnover: "Андозаи даври моҳона зарур аст",
    deposit_sum: "Андозаи депозит зарур аст",
    tax_system: "Навъи андозбандӣ зарур аст",
    legal_type: "Шакли шахси ҳуқуқӣ зарур аст",
    okved_code: "Навъи асосии фаъолият зарур аст",
    minFillingPhotos: "Минималии миқдори файлҳо - {amount}",
    notValidPromocode: "Рамзи ташвиқ вуҷуд надорад",
    cyrillicOnly: "Танҳо кириллӣ ва лотинӣ",
    haveInn: "Шахси ҳуқуқӣ бо ин {option} аллакай мавҷуд аст",
    addressWithoutNumber: "Рақами бино/сохтмон, ҳуҷра зарур аст",
    login: "Логинро ворид кунед",
    empryNamedField: "{option} зарур аст",
    passwordMismatch: "Паролҳо мувофиқат намекунанд",
    address: "Суроға бо рақами бино/сохтмон, ҳуҷра зарур аст",
    fieldLengthFromTo: "Майдон бояд аз {from} то {to} рақам дошта бошад",
    necessaryEnterMinChars: "Ақалан {minChars} аломат ворид кардан зарур аст",
    workHours: "Соатҳои корӣ дар рӯзҳои интихобшударо муайян кунед",
    timeFormat: "Формати нодурусти вақт",
    minImagesUpload: "Ақалан {minImages} тасвир бор кунед",
  },

  tooltips: {
    registration: {
      deposit:
        "Қолдиши минималӣ дар ҳисоб. Маблағе, ки дар баланс дар вақти бозпас гирифтани маблағҳо боқӣ мемонад.",
    },
  },

  globalMessagesButton: {
    "tt-update": "Ба зербахши нави «Нуқатҳои тиҷорат» гузаред",
    "clients-update": "Санҷед",
    "product-release": "Санҷед",
    "review-update-release": "Санҷед",
  },

  declinationHelperWords: {
    years: [" сол", " сол", " сол"],
    days: [" рӯз", " рӯз", " рӯз"],
    grades: [" баҳо", " баҳо", " баҳо"],
    symbols: [" аломат", " аломат", " аломат"],
    result: [" натиҷа", " натиҷа", " натиҷа"],
    review: [" аккола", " аккола", " аккола"],
    star: [" ситора", " ситора", " ситора"],
    clients: [" муштарӣ", " муштарӣ", " муштарӣ"],
    product: [" маҳсулот", " маҳсулот", " маҳсулот"],
    entities: [" шахси ҳуқуқӣ", " шахси ҳуқуқӣ", " шахси ҳуқуқӣ"],
  },

  noData: {
    title: "Маълумот нест",
    emptyHistory: "Таърихи шумо холӣ аст",
  },

  mobileFiltersName: {
    "trading-points": "Нуқатҳои тиҷорат",
    category: "Гурӯҳ",
    "product-status": "Ҳолати маҳсулот",
    "review-status": "Навъи аккола",
    sort: "Ба тартиб додан",
    date: "Давра",
  },

  debt: {
    title: "Қарз",
    text: "Онро бо ёрии ҳисобе, ки ба почтаи электронӣ фиристода шудааст, пардохт кунед, ё худ мустақилан дар бахши «Баланс» эҷод кунед",
    link: "Ба пуркунии қарз гузаред",
    message:
      "Шумо бояд қарзи ба андозаи {debt}&nbsp;{currency}-ро пардохт кунед <br>" +
      "Пардохтро бо яке аз тарзҳо иҷро кардан мумкин аст: дар кабинетҳои шахсӣ ҳисоб эҷод кунед ё ҳисоберо, ки ба почтаи электронӣ фиристода шудааст, зеркашӣ кунед.",
  },

  permissions: {
    analytics: "Таҳлил",
    "legal-entity": "Шахсҳои ҳуқуқӣ",
    "trading-point": "Нуқатҳои тиҷорат",
    employee: "Кассирҳо",
    document: "Ҳуҷҷатҳо",
    tariff: "Тарифҳо",
    operation: "Таърихи амалиётҳо",
    "act-and-receipt": "Ҳуҷатҳо ва ҳисобҳо",
    manager: "Менеҷерҳо",
    cashback: "Нақд кардани баллҳо",
    balance: "Баланс",
    points: "Нуқтаҳо ба кассирҳо",
    client: "Рӯйхати муштариён",
    spread: "Пахш кардани кортҳои Wallet",
    "wallet-pass": "Тарҳи корти Wallet",
    review: "Акколаҳо",
    "noncash-tips": "Накдӣ маслиҳатҳо",
    "check-counterparties": "Санҷиши контрагентҳо",
    "push-notifications": "Огоҳиҳои Push",
    "client-portrait": "Портрети муштарӣ",
    "active-wait": "Нақд кардани баллҳо (Интизории фаъол)",
    "e-menu": "Менюи электронӣ",
    "tg-notifications": "Огоҳиҳо дар Telegram",
    faq: "Саволҳои зуд-зуд додашаванда",
    terminal: "Processing",
    promotion: "Аксияҳо",
    cashback_group: "Нақд кардани баллҳо (Гурӯҳҳои муштариён)",
    payment_info: "Усулҳои пардохт",
    orders: "Фармоишҳо",
    "trading-point-promotion": "Ташвиқот",
    "gift-card": "Кортҳои тӯҳфа",
  },

  promotionServices: {
    servicesList: {
      "xxl-tag": {
        name: "Андозаи XXL-и корт",
        description:
          "Афзоиши андозаи корти муассисаи шумо ва ҷойгиркунии баджи «Ҷойи болоӣ» дар он",
        fullDescription:
          "<ul>" +
          "<li><span>●</span><p>Корти муассисаи шумо дар андоза калон карда мешавад, ва инчунин бо баджи «Ҷойи болоӣ» дар саҳифаи «Муассисаҳо» дар сомонаи rcpay.ru ва барномаи мобилии RC PAY дар доираи он шаҳр ва гурӯҳ, ки он мансуб аст, ҷудо карда мешавад.</p></li>" +
          "<li><span>●</span><p>Муддати ҷойгиркунӣ – 1 ҳафта, 1 моҳ ё 3 моҳ аз лаҳзаи ташкил ва пардохти фармоиш дар кабинети шарик.</p></li>" +
          "<li><span>●</span><p>Интихоби муддати ҷойгиркуниро дар марҳилаи ташкили фармоиш метавон кард.</p></li>" +
          "<li><span>●</span><p>Дар фармоиши ин хизмат ба тӯҳфа шумо инчунин аломати махсуси муассисаи худро дар харита мегиред.</p></li>" +
          "</ul>",
      },
      tag: {
        name: "Баджи «Ҷойи болоӣ»",
        description:
          "Ҷойгиркунии баджи «Ҷойи болоӣ» дар корти муассисаи шумо ва кӯчидани он болотар дар рӯйхати умумӣ",
        fullDescription:
          "<ul>" +
          "<li><span>●</span><p>Корти муассисаи шумо бо баджи «Ҷойи болоӣ» ҷудо карда мешавад ва болотар дар рӯйхати саҳифаи «Муассисаҳо» дар сомонаи rcpay.ru ва барномаи мобилии RC PAY дар доираи он шаҳр ва гурӯҳ, ки он мансуб аст, кӯчида мешавад.</p></li>" +
          "<li><span>●</span><p>Муддати ҷойгиркунӣ – 1 ҳафта, 2 ҳафта, 1 моҳ ё 3 моҳ аз лаҳзаи ташкил ва пардохти фармоиш дар кабинети шарик.</p></li>" +
          "<li><span>●</span><p>Интихоби муддати ҷойгиркуниро дар марҳилаи ташкили фармоиш метавон кард.</p></li>" +
          "<li><span>●</span><p>Дар фармоиши ин хизмат ба тӯҳфа шумо инчунин аломати махсуси муассисаи худро дар харита мегиред.</p></li>" +
          "</ul>",
      },
      top: {
        name: "Ҷойи 1 ё 2",
        description:
          "Ҷойгиркунии корти муассисаи шумо дар ҷойҳои 1 ё 2 дар рӯйхат (бе тағйири шакли ва андозаи он)",
        fullDescription:
          "<ul>" +
          "<li><span>●</span><p>Корти муассисаи шумо дар ҷойҳои 1 ё 2 дар саҳифаи «Муассисаҳо» дар сомонаи rcpay.ru ва барномаи мобилии RC PAY дар доираи он шаҳр ва гурӯҳ, ки он мансуб аст, ҷойгир карда мешавад.</p></li>" +
          "<li><span>●</span><p>Ҷойгиркунӣ дар ҷойҳои 1 ё 2 бо тартиби ташкил ва пардохти фармоиши ин хизмат муайян карда мешавад.</p></li>" +
          "<li><span>●</span><p>Муддати ҷойгиркунӣ – 2 ҳафта аз лаҳзаи ташкил ва пардохти фармоиш дар кабинети шарик.</p></li>" +
          "<li><span>●</span><p>Дар фармоиши ин хизмат ба тӯҳфа шумо инчунин аломати махсуси муассисаи худро дар харита мегиред.</p></li>" +
          "</ul>",
      },
      hint: "Дар вақти ҳозир ҳамаи слотҳои дастрас барои ин хизмат дар шаҳри нуқти тиҷорати шумо ишғол шудаанд. Фармоиш аз санаи муайяншуда имконпазир хоҳад буд.",
    },
    periodsList: {
      "7 days": "1 ҳафта",
      "14 days": "2 ҳафта",
      "30 days": "1 моҳ (30 рӯз)",
      "90 days": "3 моҳ (90 рӯз)",
    },
  },
};
